export default "__VITE_ASSET__DNkfCvyD__"